import { StyledCategoriesWidget } from './CategoriesWidget.style';
import CategoriesList from './CategoriesList/CategoriesList';
import SelectedCategory from './SelectedCategory/SelectedCategory';
import useCategoriesWidget from './useCategoriesWidget/useCategoriesWidget';
import EmptyState from '../../ResourceAllocationOverview/EmptyState';
import { EMPTY_STATE_MODULES } from '../../ResourceAllocationOverview/EmptyState/EmptyState';

const CategoriesWidget = () => {
  const { categories, selectedCategory, setSelectedCategory, isLoading } =
    useCategoriesWidget();

  if (!isLoading && categories.length === 0)
    return <EmptyState module={EMPTY_STATE_MODULES.INVESTMENT_CARVING} />;

  return (
    <StyledCategoriesWidget>
      <CategoriesList
        categories={categories}
        selectedCategory={selectedCategory}
        onClick={category => setSelectedCategory(category)}
        isLoading={isLoading}
      />
      <SelectedCategory
        selectedCategory={selectedCategory}
        categories={categories}
        isLoading={isLoading}
      />
    </StyledCategoriesWidget>
  );
};

export default CategoriesWidget;
